module.exports = __webpack_public_path__ + "img/chris_g_04.0aa1d99d.jpg";